module.exports = __webpack_public_path__ + "img/sk-partners-refresher.e75b84cf.png";